module.exports = __webpack_public_path__ + "static/media/downloadfile.f3653039.svg";